import React from "react"

const PlusIconGray = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            <path d="M11.125 5C11.125 4.65482 10.8452 4.375 10.5 4.375C10.1548 4.375 9.875 4.65482 9.875 5V9.375H5.5C5.15482 9.375 4.875 9.65482 4.875 10C4.875 10.3452 5.15482 10.625 5.5 10.625H9.875V15C9.875 15.3452 10.1548 15.625 10.5 15.625C10.8452 15.625 11.125 15.3452 11.125 15V10.625H15.5C15.8452 10.625 16.125 10.3452 16.125 10C16.125 9.65482 15.8452 9.375 15.5 9.375H11.125V5Z" fill="#C6C6C6" />
        </svg>
    )
}
export default PlusIconGray